import React, { useEffect, useState } from 'react'
import { TextField } from '@material-ui/core';
import UserService from '../../services/users';
export default function Baby(props) {
    const [rows, setRows] = useState([])
    const [user,setUser] = useState();

    useEffect(()=>{
        
        if(typeof props.user === 'string'){
            UserService.get(props.user)
            .then(result=>{ setUser(result)})
        }else{
            setUser(props.user);
        }
     
    },[props.user])

    const getHours = (year) => { 
        if( user.babyhours){
            for (let i = 0; i < user.babyhours.length; i++) {
                if (user.babyhours[i].year === year) {
                    return user.babyhours[i].total;
                }
            }
        }
      
        return 0;
    }

    const setHours = (year, value) => { 
        let tmpItem = Object.assign([], user.babyhours);
        let found = false;
        for (let i = 0; i < tmpItem.length; i++) {
            if (tmpItem[i].year === year) {
                tmpItem[i].total = value;
                found = true;
            }
        }
        if (found === false) {
            tmpItem.push({ year: year, total: value })
        }
        props.onChange(tmpItem)
    }

    const getHoursBabiesApproved = (year) => {
        let items = [];
        if(props.babies){
            items = (props.babies.filter(item => { return new Date(item.date).getFullYear() === year }));
        }
        let totalMinutes = 0;
        for (let i = 0; i < items.length; i++) {
            totalMinutes += items[i].minutes;
        }
        return Math.round(((totalMinutes / 60)) * 100, 2) / 100;
    }

    useEffect(() => { 
        if(user){
            let tmpItems = [];
            for (let y = 2018; y <= (new Date().getFullYear() + 1); y++) {
                const assigned = getHours(y);
                const hoursApproved = getHoursBabiesApproved(y);
                tmpItems.unshift(<tr key={y}><td>{y}</td><td>{props.readonly ? assigned:<TextField value={assigned} onChange={ev => setHours(y, ev.target.value)} type="number"></TextField>}</td><td>{hoursApproved}</td><td>{Math.round( (assigned-hoursApproved)*100) /100 }</td></tr>)
            }
            setRows(tmpItems)
        }
        

    }, [user, props.babies])

    return (
       <div className="padding">
           {user &&   <table><tbody>
                <tr><td><b>Jaar</b></td><td><b>Uren toegewezen</b></td><td><b>Uren goedgekeurd</b></td><td><b>Uren resterend</b></td></tr>
                {rows}
            </tbody></table>}
        </div>
    )
}
